import { render, staticRenderFns } from "./Adm_funcionario.vue?vue&type=template&id=2760d68a"
import script from "./Adm_funcionario.vue?vue&type=script&lang=js"
export * from "./Adm_funcionario.vue?vue&type=script&lang=js"
import style0 from "./Adm_funcionario.vue?vue&type=style&index=0&id=2760d68a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports